import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-inside-disable',
    templateUrl: './inside-disable.component.html',
    standalone: true,
    imports: [NgClass]
})
export class InsideDisableComponent {
    @Input() isDisabled: boolean;
}
